import {
  getSyncableRewards,
  updateRewardEntry,
} from "./offlineQueueService";

export async function syncQueuedRewards() {
  if (!navigator.onLine) return;

  const syncableItems = await getSyncableRewards(20);

  if (syncableItems.length === 0) return;

  for (const item of syncableItems) {
    await updateRewardEntry(item.local_id, {
      status: "syncing",
      message: "Syncing...",
    });
  }

  try {
    const response = await fetch("/api/v1/reward-entries/batch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({
        entries: syncableItems.map((item) => ({
          local_id: item.local_id,
          phone_number: item.phone_number,
          order_amount: item.order_amount,
        })),
      }),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || "Sync failed");
    }

    for (const serverItem of result.data || []) {
      await updateRewardEntry(serverItem.local_id, {
        status: serverItem.status,
        server_id: serverItem.id,
        points: serverItem.points,
        message: serverItem.message,
        synced_at: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error("Reward sync failed:", error);

    for (const item of syncableItems) {
      await updateRewardEntry(item.local_id, {
        status: "queued",
        message: "Sync failed. Will retry.",
      });
    }
  }
}